export const UNIQUE_KEY_ITEMS = ['sii', 'unemployment', 'debtFree'];
